import { Grid } from '@material-ui/core'
import React, {useState, useEffect} from 'react'
import LineInputText from '../../../../../components/Inputs/LineInputText/LineInputText'
import ModalBase from '../../../../../components/Modals/ModalBase'
import DisplayText from '../../../../../components/Texts/DisplayText'
import { onValidateForm } from '../../../../../shared/utility'
import {formData } from './data'
import SubmitModalButton from '../../../../../components/Buttons/SubmitModalButton'
import {request_add_approval_contact, request_check_username} from '../../requests'

const AddEmailModal = props => {

    const {initData, patientID, open, onClose, onRequetsContacts} = props
    const [form, setForm] = useState(JSON.parse(JSON.stringify(formData)))
    const [valid, setValid] = useState(false)
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        setForm(JSON.parse(JSON.stringify(formData)))
    }, [open])


    const onInputChange = (data) => {
        const id = data.config.id;
        let temp = {...form};
        temp[id] = {...data};
        if(id === 'password') temp.passwordConfirmation.value2 = data.value
        if(id === 'username') onUsernameVerification(data.value)
        setValid(onValidateForm(temp))
        setForm(temp)
        setError(null)
    }

    const onUsernameVerification = async(data) => {
        try {
            await request_check_username(data)
        } catch (error) {
            let temp = {...form}
            temp.username.isValid = false
            temp.username.value = data
            temp.username.config.helper = 'El usuario ya existe'
            setForm(temp)
        }

    }

    const onSubmit = async() => {
        if(!valid){
            setError('Llena los campos faltantes')
            return
        }
        
        let data2send = {}
        Object.keys(form).forEach(item => {
            if(form[item].isValid && item !== 'passwordConfirmation'){
                data2send = {...data2send, [item]: form[item].value}
            }
        })
        console.log(data2send)
        setLoading(true)
        try {
            await request_add_approval_contact(data2send)
            onRequetsContacts()
            //setLoading(false)
            //onClose()
        } catch (error) {
            console.log(error)
            setError('Hubo un error')
        }
        setLoading(false)


    }
    

    return(
        <ModalBase open={open} onClose={onClose} maxWidth='sm'>
            <div>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <DisplayText variant='h6'>Nuevo correo de aprobación</DisplayText>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={4}>
                            <Grid item xs={12} md={12}>
                                <LineInputText 
                                data={form.name}
                                onChange={onInputChange}/>
                            </Grid> 
                            <Grid item xs={12} md={12}>
                                <LineInputText 
                                data={form.email}
                                onChange={onInputChange}/>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <SubmitModalButton label='Agregar' error={error} loading={loading} onSubmit={onSubmit}/>
                    </Grid>
                </Grid>
            </div>
        </ModalBase>
    )
}

export default AddEmailModal